export function sorterHelper(a, b) {
    if (a.value) {
        return b.value ? a.value.localeCompare(b.value) : -1
    } else if (b.value) {
        return a.value ? b.value.localeCompare(a.value) : 1
    } else {
        return -1
    }
}